<div class="widgets-container" *ngIf="courseExperienceCatalog">
    <mat-toolbar class="grow-toolbar px-0 mb-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="sidebar-btn w-full" fxLayout="row" fxLayoutAlign="start center">
            <button mat-icon-button (click)="sidenavService.toggle()" *ngIf="!(screenWidth | isLargeScreen)">
                <mat-icon>apps</mat-icon>
            </button>
            <div fxlayout="row" fxLayoutAlign="space-between center" class="w-full">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <button mat-icon-button class="mr-4" (click)="goBack()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    <div fxLayout="column">
                        <h5 class="parent-name">{{ 'ENGAGE.EXPERIENCE.TITLE.PLURAL' | translate }} / {{ experience.name }}</h5>
                        <h2>{{ 'COURSE_CATALOG.LABEL.CATALOG_CONTENT' | translate }}</h2>
                    </div>
                </div>

                <div fxLayoutAlign="flex-end center">
                    <mat-slide-toggle class="mr-24" [formControl]="visible" (change)="visibleToggleChanged($event)">
                        {{ 'CUSTOM_USER_PROPERTIES.ADD_NEW_DIALOG.FORM.VISIBLE' | translate }}
                    </mat-slide-toggle>

                    <app-white-button [icon]="'visibility'" [label]="'GENERAL.BUTTON.PREVIEW_CATALOG'" (onClick)="preview()"></app-white-button>
                </div>
            </div>
        </div>
    </mat-toolbar>

    <mat-toolbar-row class="table-toolbar" fxLayout="row" fxLayoutAlign="space-between center">
        <span class="toolbar-title">{{ 'COURSES.LABEL.CURRENCY' | translate }}</span>
    </mat-toolbar-row>
    <div class="bg-white p-24 mb-16">
        <form [formGroup]="formGroup">
            <mat-form-field class="w-100-p">
                <mat-label>{{ 'COURSES.LABEL.CURRENCY' | translate }}</mat-label>
                <mat-select formControlName="currency">
                    <mat-option *ngFor="let currency of currencyOptions" [value]="currency">{{ currency }}</mat-option>
                </mat-select>
            </mat-form-field>
        </form>
    </div>

    <mat-toolbar-row class="table-toolbar mt-8" fxLayout="row" fxLayoutAlign="space-between center">
        <span class="toolbar-title">{{ 'ENGAGE.POSTING.LABELS.TITLE' | translate }}</span>

        <div fxLayout="row" fxLayoutAlign="end center">
            <app-flat-button [label]="'GENERAL.BUTTON.SAVE_CHANGES'" (onClick)="saveChanges()" [disabled]="formGroup.pristine"></app-flat-button>
        </div>
    </mat-toolbar-row>
    <div class="bg-white p-24">
        <form class="experience-form" [formGroup]="formGroup">
            <div class="experience-form-language">
                <button
                    fxLayout="row-reverse"
                    fxLayoutAlign="space-between center"
                    [class.selected]="selectedExperienceLanguageId === 'translation_' + lang.id"
                    mat-menu-item
                    *ngFor="let lang of languageService.languages | filterLanguages"
                    (click)="changeExperienceLanguage(lang.id)"
                >
                    <div fxLayout="row" fxLayoutAlign="center center" class="w-full">
                        <img class="flag mr-16" [src]="'assets/images/flags/' + lang.flag + '.svg'" />
                        <span class="iso" [translate]="lang.translate">{{ lang.title }}</span>
                    </div>

                    <mat-icon class="mr-0">{{ checkValue(lang.id) ? 'checkmark' : 'close' }}</mat-icon>
                </button>
            </div>

            <div fxLayout="column" class="experience-form-information w-100-p">
                <div *ngIf="growKeywords.length">
                    <div fxLayoutAlign="space-between center">
                        <h3 class="title my-0">{{ 'GENERAL.LABEL.KEYWORDS_YOU_CAN_USE' | translate }}:</h3>
                    </div>
                    <div class="keywords-wrapper mb-32">
                        <div class="keyword-tag pointer" *ngFor="let keyword of growKeywords" (click)="copyKeywordToClipboard(keyword)">
                            <span>{{ keyword }}</span>
                            <mat-icon svgIcon="keyword_tag"></mat-icon>
                        </div>
                    </div>
                </div>

                <div formArrayName="language">
                    <div *ngFor="let control of formGroup.get('language')['controls']; let i = index">
                        <div [formGroupName]="i" *ngIf="selectedExperienceLanguageId === control.get('id').value">
                            <mat-form-field class="w-100-p">
                                <mat-label>{{ 'COURSE_CATALOG.LABEL.CATALOG_TITLE' | translate }}</mat-label>
                                <input matInput type="text" formControlName="title" />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="course-offering-group-container mt-16 bg-white">
        <mat-toolbar fxLayout="row" fxLayoutAlign="space-between center" class="course-catalog-categories-toolbar mt-24">
            <mat-label>
                {{ 'COURSE_CATALOG.LABEL.CATEGORIES_INCLUDED_IN_THIS_CATALOG' | translate }}
            </mat-label>

            <div fxLayout="row" fxLayoutAlign="space-between center">
                <app-white-button [icon]="'add'" [label]="'COURSES.BUTTON.ADD_CATEGORY'" (onClick)="openAddCategoryDialog()"></app-white-button>
            </div>
        </mat-toolbar>

        <div
            class="subcategory-list-container bg-white p-24"
            *ngIf="courseExperienceCatalog.categories.length"
            cdkDropList
            [cdkDropListData]="courseExperienceCatalog.categories"
            (cdkDropListDropped)="dropSubcategory($event)"
        >
            <div class="custom-drop-placeholder" *cdkDragPlaceholder></div>
            <mat-card
                fxLayout="row"
                class="subcategory-card pointer mb-12 mat-elevation-z0 bg-gray-100"
                cdkDrag
                cdkDragPreview
                *ngFor="let subcategory of courseExperienceCatalog.categories; index as i; first as isFirst; last as isLast"
            >
                <div class="custom-drop-placeholder" *cdkDragPlaceholder></div>
                <div class="mr-16" fxLayoutAlign="center center" cdkDragHandle>
                    <mat-icon class="pointer">menu</mat-icon>
                </div>
                <mat-card-content fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="row" fxLayoutAlign="flex-start center">
                        <div
                            class="image-container mr-16"
                            [ngStyle]="subcategory.image && { background: 'url(' + subcategory.image.url + ') center / cover no-repeat ' }"
                            [class.no-image]="!subcategory.image"
                        >
                            <mat-icon class="bg-icon" svgIcon="bg_illustration" *ngIf="!subcategory.image"> </mat-icon>
                        </div>
                        <h3 class="my-0" tabindex="0">{{ subcategory.name }}</h3>
                    </div>

                    <div class="h-full" fxLayout="column" fxLayoutAlign="center flex-end">
                        <button class="more-menu" mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="More" (click)="$event.stopPropagation()">
                            <mat-icon class="mat-icon-more-vert">more_vert</mat-icon>
                        </button>

                        <mat-menu #moreMenu="matMenu" xPosition="before">
                            <app-menu-item-button
                                [disabled]="isFirst"
                                [icon]="'move_up'"
                                [label]="'GENERAL.BUTTON.MOVE_UP'"
                                (onClick)="moveCourseStructureCategoryUp(subcategory)"
                            ></app-menu-item-button>

                            <app-menu-item-button
                                [disabled]="isLast"
                                [icon]="'move_down'"
                                [label]="'GENERAL.BUTTON.MOVE_DOWN'"
                                (onClick)="moveCourseStructureCategoryDown(subcategory)"
                            ></app-menu-item-button>

                            <app-menu-item-button
                                [icon]="'delete'"
                                [label]="'GENERAL.BUTTON.REMOVE'"
                                (onClick)="openRemoveCourseStructureCategoryModal(subcategory)"
                            ></app-menu-item-button>
                        </mat-menu>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>
